<template>
    <div class="form">
    <a-card title="新增日志库">
        <v-gobackbutton slot="extra" >返回</v-gobackbutton>
        <a-spin :spinning="floading">
            
            <a-form-model :model="record" ref="ruleForm" :rules="rules" :layout="formItemLayout"  :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-form-model-item ref="projectname" label="Project名称" prop="projectname">
                    <span style="font-weight:bolder;font-size:16px;padding-left:10px;">{{record.projectname}}</span>
                </a-form-model-item>
                <a-form-model-item ref="type" label="类型" prop="type">
                    <a-radio-group v-model="record.type" @change="handleTypeChange">
                        <a-radio-button value="1">
                            业务埋点
                        </a-radio-button>
                        <a-radio-button value="2">
                            开发埋点
                        </a-radio-button>
                    </a-radio-group>
                </a-form-model-item>


                

                <a-form-model-item ref="logstorename" label="日志库名称" prop="logstorename">
                    <a-input
                        v-model="record.logstorename"
                        placeholder="建议使用svn项目名"
                        :addon-after="record.type == 1 ? bpropro : ''" 
                        @blur="
                            () => {
                                $refs.logstorename.onFieldBlur();
                            }
                            "
                    />
                </a-form-model-item>

                <a-form-model-item v-if="record.type==1" ref="logstorenametest" label="测试环境日志库" prop="logstorenametest">
                    <span>{{record.logstorename + bpropre }}</span>
                </a-form-model-item>

                <a-form-model-item ref="ttl" label="数据保存天数" prop="ttl">
                    <a-input-number v-model="record.ttl" placeholder="1 ~ 3650" :disabled="record.type == 1"
                        v-decorator="['input-number', { initialValue: record.ttl }]" :min="1" :max="3650"
                        @blur="
                            () => {
                                $refs.ttl.onFieldBlur();
                            }
                            " />
                </a-form-model-item>

                 

                <a-form-model-item  :wrapper-col="{ span: 14, offset: 14 }" >
                    <a-button type="primary" @click="handleOk" >
                        创建
                    </a-button>
                    <a-button style="margin-left: 10px;" @click="handleCancel">
                        取消
                    </a-button>
                </a-form-model-item>
            </a-form-model>
        </a-spin>
    </a-card>
    </div>
  
</template>
<script>
const projectNameExtra = "-zl-device"
export default {
    data() {
        return {
            labelCol: { span: 4 },
            wrapperCol: { span: 14 },
            projectNameExtra,
            bpropro:'-business-pro',
            bpropre:'-business-test',
            floading:false,
            record:{
                type:'1',
                projectname:'',
                logstorename:'',
                logstorenametest:'',
                ttl:90,
            },
            rules: {
                projectname: [
                    { required: true, message: '请输入系统名称', trigger: 'blur' },
                    { min: 1, max: 50, message: '请输入1~50个字符', trigger: 'blur' },
                ],
                logstorename: [
                    { required: true, message: '请输入日志库名称', trigger: 'blur' },
                    { min: 1, max: 100, message: '请输入1~100个字符', trigger: 'blur' },
                ],
                ttl: [
                    { required: true, message: '请输入日志库保存天数', trigger: 'blur' }
                ],
            },
            confirmLoading: false,
            formItemLayout:'horizontal',
        };
    },
  
    methods: {
        handleTypeChange(){
            if(this.record.type == 1){
                this.record.ttl = 90;
            }
            else{
                this.record.ttl = 30;
            }
        },
        handleOk() {
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    let params = {};
                    params.projectname = this.record.projectname;
                    params.logstorename = this.record.logstorename;
                    params.ttl = this.record.ttl;
                    params.uraparams = false;
                    if(this.record.type == 1){
                        params.logstorename = this.record.logstorename + this.bpropro;
                        this.sendCreateRequest(params,false);
                        params.logstorename = this.record.logstorename + this.bpropre;
                        setTimeout(() => {
                            this.sendCreateRequest(params,true);
                        }, 2000);
                    }
                    else{
                        this.sendCreateRequest(params,true);
                    }
                } else {
                    return false;
                }
            });
        },

        handleCancel() {
            this.resetForm();
            this.$router.back(-1);
        },
        resetForm() {
            this.$refs.ruleForm.resetFields();
        },
        sendCreateRequest(params,flag){
            this.floading = true;
            // // //新增
            this.$store
                .dispatch({
                    type: "logservice/addlogstore",
                    params: params
                })
                .then((response) => {
                    
                    if(response.status == 200 && response.data.success == 1){
                        this.message.success("创建成功");
                        this.handleCancel();
                    }
                    if(flag){
                        this.floading = false;
                    }
                        
                }).catch(() => {
                    if(flag){
                        this.floading = false;
                    }
                });
        }
    },

    mounted(){
        let query = this.$route.query;
        this.record.projectname = query.projectname;
        
    }
};
</script>

<style scoped>
.ant-form-inline .ant-form-item{
    margin-right:40px;
}
</style>
